export enum Size {
  SMALL = "small",
  MIDDLE = "middle",
  LARGE = "large",
}
